<template>
  <div class="crud">
    <DataTable :value="entities" selectionMode="single" :selection.sync="newTask" @row-select="onRowSelect"
               dataKey="_id" :paginator="true" :rows="15">
      <Column field="workload" :header="$t('crud.task.labels.workload')"></Column>
      <Column field="summary" :header="$t('crud.task.labels.summary')"></Column>
      <Column field="description" :header="$t('crud.task.labels.description')"></Column>
      <Column field="checked" :header="$t('crud.task.labels.checked')"></Column>
      <template #footer>
        <Button :label="$t('shared.actions.create')" icon="pi pi-plus" @click="createTask" class="p-button-primary" />
      </template>
    </DataTable>

    <Dialog :visible.sync="dialogVisible" :style="{width: '400px'}" :modal="true">
      <template #header>
        <span>{{ $t('crud.task.modals.titles.' + action) }}</span>
      </template>
      <div>
        <label for="workload">{{ $t('crud.task.labels.workload') }}</label>
        <input id="workload" v-model="newTask.workload" name="workload" type="number">
      </div>
      <div>
        <label for="summary">{{ $t('crud.task.labels.summary') }}</label>
        <input id="summary" v-model="newTask.summary" name="summary" type="text">
      </div>
      <div>
        <label for="description">{{ $t('crud.task.labels.description') }}</label>
        <input id="description" v-model="newTask.description" name="description" type="text">
      </div>
      <div>
        <label for="checked">{{ $t('crud.task.labels.checked') }}</label>
        <input id="checked" v-model="newTask.checked" name="checked" type="checkbox">
      </div>
      <template #footer>
        <Button v-if="action === 'update'" :label="$t('shared.actions.delete')" icon="pi pi-trash" @click="deleteTask" class="p-button-danger"></Button>
        <Button :label="$t('shared.actions.save')" icon="pi pi-check" @click="saveTask" class="p-button-success"></Button>
        <Button :label="$t('shared.actions.cancel')" icon="pi pi-times" @click="cancelEdit" class="p-button-secondary"></Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Dialog from "primevue/components/dialog/Dialog";
  import Button from 'primevue/button';
  import Task from '../../models/task.model';

  export default {
    name: 'Tasks',
    components: {
      Dialog,
      DataTable,
      Column,
      Button
    },
    props: {},
    data: () => {
      return {
        newTask: {},
        dialogVisible: false,
        action: '',
        entityName: ''
      }
    },
    computed: {
      entities() {
        return this.$store.state.tasks;
      }
    },
    methods: {
      onRowSelect: function(event) {
        this.action = 'update';
        this.newTask = {...event.data};
        this.dialogVisible = true;
      },
      createTask: function() {
        this.action = 'create';
        this.resetNewTask();
        this.dialogVisible = true;
      },
      deleteTask: function() {
        this.$store.dispatch('removeTask', this.newTask).then((succeed) => {
          if (succeed) {
            this.$toast.add({severity: 'success', summary: this.$t('crud.task.toasts_msg.summary.delete'),
                             detail: this.$t('crud.task.toasts_msg.success.delete'), life: 3000});
            this.dialogVisible = false;
            this.resetNewTask();
          } else {
            this.$toast.add({severity: 'error', summary: this.$t('crud.task.toasts_msg.summary.delete'),
                             detail: this.$t('crud.task.toasts_msg.fail.delete'), life: 3000});
          }
        });
      },
      saveTask: function () {
        if (
          this.$isNotEmpty(this.newTask.workload) && !isNaN(this.newTask.workload)
          && this.$isNotEmpty(this.newTask.summary)
          && this.$isNotEmpty(this.newTask.description)
          && this.$isNotEmpty(this.newTask.checked)
        ) {
          let dispatch = 'postTask';
          if (this.action === 'update') {
            dispatch = 'updateTask';
          }

          this.$store.dispatch(dispatch, this.newTask).then((succeed) => {
            if (succeed) {
              this.$toast.add({severity: 'success', summary: this.$t('crud.task.toasts_msg.summary.save'),
                               detail: this.$t('crud.task.toasts_msg.success.save'), life: 3000});
              this.dialogVisible = false;
              this.resetNewTask();
            } else {
              this.$toast.add({severity: 'error', summary: this.$t('crud.task.toasts_msg.summary.save'),
                               detail: this.$t('crud.task.toasts_msg.fail.save'), life: 3000});
            }
          });
        } else {
          this.$toast.add({severity: 'error', summary: this.$t('crud.task.toasts_msg.summary.validation'),
                           detail: this.$t('crud.task.toasts_msg.validation.fieldsMissing'), life: 3000
          });
        }
      },
      resetNewTask: function () {
        this.newTask = new Task({});
      },
      cancelEdit: function () {
        this.dialogVisible = false;
        this.newTask = new Task({});
      }
    },
    created: function () {
      this.$store.dispatch('fetchAll');
      this.resetNewTask();
      this.entityName = this.$t('crud.task.task')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .crud {
  }
</style>
